module.exports = __webpack_public_path__ + "static/img/dy2-3.2107def.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dy2-3.png
// module id = 955
// module chunks = 0